import apex from 'utils/Apex';

export async function getArticleId(articleId) {
  const responseJson = await apex.getArticleId(articleId);
  return responseJson;
}
